export enum NavigationTarget {
  CALENDAR_PAGE = 'CALENDAR_PAGE',
  SERVICE_PAGE = 'SERVICE_PAGE',
}
